import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  SimpleGrid,
  Image,
  Flex,
  Heading,
  Text,
  Stack,
  StackDivider,
  Icon,
  useColorModeValue,
} from '@chakra-ui/react';
import { CloseIcon } from '@chakra-ui/icons';
import writing from 'assets/family-1.jpeg';

const Feature = ({ text, icon, iconBg }) => {
  return (
    <Stack direction={'row'} align={'center'}>
      <Flex
        w={8}
        h={8}
        align={'center'}
        justify={'center'}
        rounded={'full'}
        bg={iconBg}
      >
        {icon}
      </Flex>
      <Text fontWeight={600}>{text}</Text>
    </Stack>
  );
};

Feature.propTypes = {
  text: PropTypes.string,
  icon: PropTypes.any,
  iconBg: PropTypes.any,
};

export default function Challenges() {
  return (
    <Container maxW={'6xl'} py={12}>
      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={10}>
        <Flex display={{ base: 'none', md: 'block' }}>
          <Image
            rounded={'md'}
            alt={'feature image'}
            src={writing}
            objectFit={'cover'}
          />
        </Flex>
        <Stack spacing={4}>
          <Text
            textTransform={'uppercase'}
            color={'blue.400'}
            fontWeight={600}
            fontSize={'sm'}
            bg={useColorModeValue('blue.50', 'blue.900')}
            p={2}
            alignSelf={'flex-start'}
            rounded={'md'}
          >
            Unlocking Potential
          </Text>
          <Heading fontSize={{ base: 'xl', sm: '2xl' }} fontWeight={'bold'}>
            Barriers in K-12 Writing Education
          </Heading>
          <Text color={'gray.500'} fontSize={'lg'}>
            Building skilled and confident writers is tough. Traditional methods
            often miss individual needs and the complexities of writing,
            hindering progress.
          </Text>
          <Stack
            spacing={4}
            divider={
              <StackDivider
                borderColor={useColorModeValue('gray.100', 'gray.700')}
              />
            }
          >
            <Feature
              icon={<Icon as={CloseIcon} color={'yellow.500'} w={5} h={5} />}
              iconBg={useColorModeValue('yellow.100', 'yellow.900')}
              text={'One-size-fits-all teaching fails to support all learners.'}
            />
            <Feature
              icon={<Icon as={CloseIcon} color={'yellow.500'} w={5} h={5} />}
              iconBg={useColorModeValue('yellow.100', 'yellow.900')}
              text={
                'Writing’s complex steps often lack the structured guidance students need'
              }
            />
            <Feature
              icon={<Icon as={CloseIcon} color={'yellow.500'} w={5} h={5} />}
              iconBg={useColorModeValue('yellow.100', 'yellow.900')}
              text={'Many students see writing as a boring task'}
            />
            <Feature
              icon={<Icon as={CloseIcon} color={'yellow.500'} w={5} h={5} />}
              iconBg={useColorModeValue('yellow.100', 'yellow.900')}
              text={
                'Generic feedback delays progress and lacks actionable insights'
              }
            />
          </Stack>
        </Stack>
        <Flex display={{ base: 'block', md: 'none' }}>
          <Image
            rounded={'md'}
            alt={'feature image'}
            src={writing}
            objectFit={'cover'}
          />
        </Flex>
      </SimpleGrid>
    </Container>
  );
}
